export default __webpack_public_path__ + "static/media/altIcon.44eb4f16.svg";